import type { ReasonType } from '@fv/models'

export const orderedOptions: Array<ReasonType> = [
  'urgent',
  'serviceLevel',
  'preference',
  'other',
]
